import { sendRequest } from "./base";

export const getEventById = async (id) => {
  try {
    return sendRequest(null, "GET", `events/${id}`);
  } catch (err) {
    console.error("Error while fetching event by id", err);
    return err.message;
  }
};

export const postPurchaseTickets = async (id, data) => {
  try {
    return sendRequest(data, "POST", `events/${id}/tickets/purchase`);
  } catch (err) {
    console.error("Error while fetching event by id", err);
    return err.message;
  }
};

export const getPurchaseTickets = async (id, orderId) => {
  try {
    return sendRequest(
      null,
      "GET",
      `events/${id}/tickets/verify?orderId=${orderId}`
    );
  } catch (err) {
    console.error("Error while fetching ticket details by orderId", err);
    return err.message;
  }
};
